module.exports = __webpack_public_path__ + "b24e87d5/img/ion_calendar-number.3ac5bd07.svg";